// There are a bunch of unused vars here that give guidance on usage if the contents of the
// method change
/* eslint-disable no-unused-vars */
const TOOLTIP = 'Read Only display of fixed text.';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    return code;
}

function asDataDictionary(hNode) {
    //a Label does not contribute to anything
    return [{}, {}];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
